// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getSettingsCollection } from "@ces/App/Store/Selectors/SettingsSelectors";
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";

export const XngPopulateApiParameter: any = (props: any) => {
    const pageType = getCurrentPage(props.getState()).type;
    const customAppSettings = getSettingsCollection(props.getState());

    if (!props.needFullCart) {
        const expands = (props.apiParameter.expand || []).concat(["cartLines", "restrictions", "paymentOptions"]);
        props.apiParameter.expand = [...new Set(expands)] as typeof props.apiParameter.expand;
        if (customAppSettings.cartSettings.showTaxAndShipping) {
            props.apiParameter.expand.push("tax");
        } else {
            props.apiParameter.expand = props.apiParameter.expand.filter((expand: string) => expand !== "shipping");
        }
    }
    // XNG-Change:CES-856 remove carriers on the cart page
    if (pageType === "CartPage") {
        props.apiParameter.expand = props.apiParameter.expand.filter((expand: string) => expand !== "carriers");
    }
    props.apiParameter.timestamp = `${new Date().getTime()}`;
};

addToChainAfter(chain, PopulateApiParameter, XngPopulateApiParameter);